/* Kuori · Favoritos sin app.
   Se guardan en este navegador (localStorage «kuori:favs»: [{h: handle, id, t: fecha}]), en todos los idiomas y mercados.
   - Botones: snippets/kuori-fav.liquid ([data-kuori-fav], aria-pressed).
   - Contador de la cabecera: [data-kuori-fav-count].
   - Página de favoritos: sections/kuori-favorites.liquid ([data-kuori-favs-page]); cada tarjeta se pide a
     /products/<handle>?section_id=kuori-fav-card (la tarjeta del tema, en el idioma y la moneda de la clienta).
   - Cada clic en un corazón se cuenta en el Daily (solo el producto y si se guarda o se quita: nada de la clienta). */
(() => {
  if (window.KuoriFav) return;
  const KEY = 'kuori:favs';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter((x) => x && typeof x.h === 'string' && x.h) : [];
    } catch (e) {
      return [];
    }
  };
  let list = read();
  const save = () => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* modo privado: solo en memoria */ }
  };
  const find = (h, id) => list.findIndex((x) => x.h === h || (id && String(x.id) === String(id)));
  const has = (h, id) => find(h, id) > -1;

  const syncButtons = (scope) => {
    (scope || document).querySelectorAll('[data-kuori-fav]').forEach((b) => {
      const on = has(b.dataset.handle, b.dataset.id);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      const label = on ? b.dataset.labelRemove : b.dataset.labelAdd;
      if (label) b.setAttribute('aria-label', label);
      b.classList.toggle('is-on', on);
    });
  };
  const syncCount = () => {
    document.querySelectorAll('[data-kuori-fav-count]').forEach((c) => {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-kuori-fav-link]').forEach((a) => a.classList.toggle('has-favs', list.length > 0));
  };
  const sync = () => { syncButtons(); syncCount(); };
  const emit = () => document.dispatchEvent(new CustomEvent('kuori:favs', { detail: { list: list.slice() } }));

  const add = (h, id) => {
    if (!h || has(h, id)) return;
    list.unshift({ h, id: id ? Number(id) || id : null, t: Date.now() });
    save(); sync(); emit();
  };
  const remove = (h, id) => {
    const before = list.length;
    list = list.filter((x) => !(x.h === h || (id && String(x.id) === String(id))));
    if (list.length !== before) { save(); sync(); emit(); }
  };
  const toggle = (h, id) => (has(h, id) ? (remove(h, id), false) : (add(h, id), true));

  // Recuento anónimo en el Daily (producto y día). Sin esperar respuesta; si falla, no pasa nada.
  const DAILY_FAV = 'https://kuori-daily.davidmartinez.workers.dev/api/shop/favorite';
  const tellDaily = (id, on) => {
    const product = Number(id);
    if (!Number.isSafeInteger(product) || product < 1) return;
    try {
      fetch(DAILY_FAV, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ product, on: !!on }),
        keepalive: true,
        credentials: 'omit',
        mode: 'cors',
      }).catch(() => {});
    } catch (e) { /* nunca rompe el corazón */ }
  };

  document.addEventListener('click', (event) => {
    const b = event.target.closest && event.target.closest('[data-kuori-fav]');
    if (!b) return;
    event.preventDefault();
    event.stopPropagation();
    const on = toggle(b.dataset.handle, b.dataset.id);
    tellDaily(b.dataset.id, on);
    if (on) {
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
    const status = document.getElementById('status-announcement');
    const msg = on ? b.dataset.msgAdded : b.dataset.msgRemoved;
    if (status && msg) status.textContent = msg;
  }, true);

  window.addEventListener('storage', (e) => {
    if (e.key !== KEY) return;
    list = read(); sync(); emit();
  });

  // Tarjetas que llegan después (filtros, paginación, «Sube tu look»…)
  let queued = false;
  new MutationObserver((records) => {
    if (queued) return;
    if (!records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-kuori-fav],[data-kuori-fav-count]') || n.querySelector('[data-kuori-fav],[data-kuori-fav-count]'))))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.KuoriFav = { list: () => list.slice(), has, add, remove, toggle, sync };

  /* ---------- Página de favoritos ---------- */
  const initPage = (page) => {
    const grid = page.querySelector('[data-kfp-grid]');
    const empty = page.querySelector('[data-kfp-empty]');
    const count = page.querySelector('[data-kfp-count]');
    const one = page.dataset.countOne || '1';
    const many = page.dataset.countMany || '__N__';
    const showCount = () => {
      const n = grid.querySelectorAll('[data-kfp-item]').length;
      if (count) { count.textContent = n === 1 ? one : many.replace('__N__', n); count.hidden = n === 0; }
      empty.hidden = n > 0 || page.classList.contains('is-loading');
      grid.hidden = n === 0;
    };
    const fetchCard = (fav) => fetch(`${root}products/${encodeURIComponent(fav.h)}?section_id=kuori-fav-card`, { credentials: 'same-origin' })
      .then((r) => {
        if (r.status === 404) { remove(fav.h, fav.id); return null; }
        if (!r.ok) return null;
        return r.text();
      })
      .then((html) => {
        if (!html) return null;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.kfc-item');
        return card || null;
      })
      .catch(() => null);

    const render = async () => {
      page.classList.add('is-loading');
      grid.replaceChildren();
      const favs = list.slice();
      showCount();
      const cards = await Promise.all(favs.map(fetchCard));
      cards.forEach((c, i) => {
        if (!c) return;
        c.setAttribute('data-kfp-item', '');
        c.dataset.handle = favs[i].h;
        grid.append(document.importNode(c, true));
      });
      page.classList.remove('is-loading');
      syncButtons(grid);
      showCount();
    };
    // Al quitar un corazón en esta página, la tarjeta se va (con un pequeño fundido)
    document.addEventListener('kuori:favs', () => {
      if (page.classList.contains('is-loading')) return;
      const keep = new Set(list.map((x) => x.h));
      const ids = new Set(list.map((x) => String(x.id)));
      grid.querySelectorAll('[data-kfp-item]').forEach((item) => {
        const b = item.querySelector('[data-kuori-fav]');
        const id = b && b.dataset.id;
        if (keep.has(item.dataset.handle) || (id && ids.has(id))) return;
        item.classList.add('is-leaving');
        setTimeout(() => { item.remove(); showCount(); }, 220);
      });
      if (list.length > grid.querySelectorAll('[data-kfp-item]').length) render();
    });
    render();
  };

  const start = () => {
    sync();
    document.querySelectorAll('[data-kuori-favs-page]').forEach(initPage);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
